import { IBuyRequest } from '../../schemas/BookLoad/BookLoad.schema';
import { VariableType } from 'json-to-graphql-query';
export class BookLoad {
  private readonly bookLoadState: IBuyRequest = {};

  get userId() {
    return this.bookLoadState.userId;
  }
  set userId(value) {
    this.bookLoadState.userId = value;
  }
  get carrierId() {
    return this.bookLoadState.carrierId;
  }
  set carrierId(value) {
    this.bookLoadState.carrierId = value;
  }
  set sourceSystem(value) {
    this.bookLoadState.sourceSystem = value;
  }
  get sourceSystem() {
    return this.bookLoadState.sourceSystem;
  }
  set loadId(value) {
    this.bookLoadState.loadId = value;
  }
  get loadId() {
    return this.bookLoadState.loadId;
  }
  set binRateId(value) {
    this.bookLoadState.binRateId = value;
  }
  get binRateId() {
    return this.bookLoadState.binRateId;
  }
  set amount(value) {
    this.bookLoadState.amount = value;
  }
  get amount() {
    return this.bookLoadState.amount;
  }
  set currency(value) {
    this.bookLoadState.currency = value;
  }
  get currency() {
    return this.bookLoadState.currency;
  }
  set lhlCharges(value) {
    this.bookLoadState.lhlCharges = value;
  }
  get lhlCharges() {
    return this.bookLoadState.lhlCharges;
  }
  set fsrCharges(value) {
    this.bookLoadState.fsrCharges = value;
  }
  get fsrCharges() {
    return this.bookLoadState.fsrCharges;
  }

  getRequestPayload() {
    return {
      bookLoad: {
        __variables: {
          input: 'BuyRequest'
        },
        buy: {
          __args: {
            input: new VariableType('input')
          },
          status: true,
          message: true
        }
      }
    };
  }
}
